import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../../../../../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { ScoringType } from "../../../../../misc/tools";
import { GameBaseScenario } from "../../../../GameBaseScenario";
import { scenario5BufferInMriAudioCaching, scenario5BufferInMriVideoSegments } from "../../../scenario5-buffer-in-mri";
import { BufferInMriComponentsStep0ComponentMainConfig, BufferInMriComponentsStep0ComponentPart1Config } from "../buffer-in-mri-components-step0";

export default class BufferInMriComponentsStep0Part1 extends BaseScenarioPart<GameBaseScenario> {
	private get config(): BufferInMriComponentsStep0ComponentPart1Config {
		return this.mainConfig.part1Config;
	}
	constructor(scenario: GameBaseScenario, private onDone: () => void, private id: string, private mainConfig: BufferInMriComponentsStep0ComponentMainConfig) {
		super(scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	private stepName = 'Step 1';

	public start() {
		this.section1();
	}

	public section1() {
		const context = this;
		let chapter = context.config.chapter;
		context.playVideoChapter(chapter(), () => {
			context.section2();
		})
	}

	public section2() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType1UI({
			audioUrl: scenario5BufferInMriAudioCaching.getItemByKey(scenario5BufferInMriAudioCaching.audioKeys.question1).src,
			title: this.mainConfig.scenario.props.name,
			subtitle: (this.stepName + ' - Question 1'),
			questionTitle: 'Select the one that best describes the employee\'s action ',
			options: [
				{
					title: 'Human Error',
					description: `
						<ul>
						<li>The employee is not accountable.</li>
						<li>The employee should be consoled.</li>
						<li>The employee should be interviewed and consulted during any systems level analysis.</li>
						</ul>
					`,
					feedbackHtml: `
						<p class="default-text">Correct. Mike was working appropriately to the best 
						of his knowledge. He did not make any purposeful decisions with an 
						understanding of risks created by such decisions.</p>
					`,
					isCorrect: true,
					score: ScoringType.good
				},
				{
					title: 'At Risk Behavior',
					description: `
						<ul>
						<li>The employee is accountable and should receive coaching.</li>
						<li>The employee may participate in teaching others the lessons learned.</li>
						</ul>
					`,
					feedbackHtml: `
						<p class="default-text">This is not the best option. This is not considered 
						at-risk behavior because he was not aware of the potential consequences of his actions.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'Reckless Behavior',
					description: `
						<ul>
						<li>Discipline may be warranted.</li>
						<li>The employee is accountable and should receive re-training/coaching as necessary.</li>
						<li>The employee may participate in teaching others the lessons learned.</li>
						</ul>
					`,
					feedbackHtml: `
						<p class="default-text">This is not the best option. Mike’s behavior was not 
						reckless because he was not aware of the potential consequences of his actions.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				}
			],
			
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario5BufferInMriVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType1(selectedChoices[0], (this.stepName + ' - Question 1 '), parentQuestionConfig, () => {
					this.section3();
				}, () => {
					this.section3();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[0], mentorInfo.chapterIds[1], mentorInfo.chapterIds[2], 'At Risk Behavior');
			}
		}, 0);
	}

	public section3() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType1UI({
			title: this.mainConfig.scenario.props.name,
			audioUrl: scenario5BufferInMriAudioCaching.getItemByKey(scenario5BufferInMriAudioCaching.audioKeys.question2).src,
			subtitle: (this.stepName + ' - Question 2'),
			questionTitle: 'Based on the correct answer, what is the appropriate path to take with the employee ',
			options: [
				{
					title: 'Console',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">Correct. In Just Culture, employees are to be consoled if their behavior was considered a human error.</p>
					`,
					isCorrect: true,
					score: ScoringType.good
				},
				{
					title: 'Console and coach',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">Not the best option. Coaching is needed for employee’s actions that are considered “at-risk behavior.”</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'Console, coach, and consider discipline',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">This is not the best option. The employee did not knowingly make an unsafe choice with little or no concern about risk.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				}
			],
			
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario5BufferInMriVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType1(selectedChoices[0], (this.stepName + ' - Question 2 '), parentQuestionConfig, () => {
					this.onDone();
				}, () => {
					this.onDone();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[3], mentorInfo.chapterIds[4], mentorInfo.chapterIds[5], 'Console and coach');
			}
		}, 1);
	}
}